<template>
  <span v-if="date" class="vue-moments-ago">{{ $t(prefix) }} {{ humanFormatted }} {{ $t(suffix) }}</span>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      language: {
        en: {
          few: "a few",
          postfix: ""
        },
        ro: {
          few: "cateva",
          postfix: ""
        }
      },
      epochs: {
        en: ["year", "month", "day", "hour", "minute"],
        ro: ["an", "luna", "zi", "ora", "minut"]
      },
      epochsPlural: {
        en: ["years", "months", "days", "hours", "minutes"],
        ro: ["ani", "luni", "zile", "ore", "minute"]
      },
      year: 31536000,
      month: 2592000,
      day: 86400,
      hour: 3600,
      minute: 60,
      humanReadable: "",
      humanDifference: 0,
      humanWord: "moment"
    };
  },

  props: {
    prefix: {
      type: String,
      default: "posted"
    },
    suffix: {
      type: String,
      default: "ago"
    },
    date: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      default: "en"
    }
  },

  mounted() {
    setInterval(() => {
      this.getSeconds(this.date);
    }, 1000);
  },

  computed: {
    humanFormatted() {
      if (this.humanDifference === 0) {
        return (
          this.language[this.lang].few +
          " " +
          this.humanWord +
          this.language[this.lang].postfix
        );
      } else if (this.humanDifference > 1) {
        return (
          this.humanDifference +
          " " +
          this.humanWord +
          this.language[this.lang].postfix
        );
      } else {
        return this.humanDifference + " " + this.humanWord;
      }
    }
  },

  methods: {
    getSeconds(time) {
      let seconds = moment().diff(moment(time), "seconds");
      this.humanReadable = this.getDuration(seconds);
      if (this.humanReadable) {
        this.humanDifference = this.humanReadable.interval;
        this.humanWord = this.humanReadable.humanEpoch;
      }
    },
    getDuration(seconds) {
      let epoch, interval;
      let humanEpoch;
      for (let i = 0; i < this.epochs[this.lang].length; i++) {
        epoch = this.epochs.en[i];
        humanEpoch = this.epochs[this.lang][i];
        interval = Math.floor(seconds / this[epoch]);
        if (interval >= 1) {
          return {
            interval: interval,
            humanEpoch: this.epochsPlural[this.lang][i]
          };
        }
      }
    }
  }
};
</script>

<style scoped>
.vue-moments-ago {
  font-size: 12px;
}
</style>
